// extracted by mini-css-extract-plugin
export default {"pageWrap":"fc-z","fullWidth":"gc-z","heading":"hc-z","fullBleed":"ic-z","hidden":"jc-z"};